import { queryClient } from 'App';

// The import request screens are socket-only — no interval, no refetch on mount
// — so a dropped connection is the one way they can silently fall behind. A
// reconnect refetches them once to close that gap. The first connect is skipped:
// the queries mount and fetch on their own.
let hasConnected = false;

export default () => {
  if (!hasConnected) {
    hasConnected = true;
    return;
  }

  queryClient.invalidateQueries(['import-request']);
  queryClient.invalidateQueries(['import-requests']);
};
